export function filterMethod(filter: any, row: any, rowName: string) {
    if (row[rowName] && row[rowName]) {
        return -1 !== row[rowName].toUpperCase().indexOf(filter.value.toUpperCase())
    } else {
        return false
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/ReactTableHelper.ts